// 预约状态;0：待处理 1：审核中 2：已通过（正式） 3：已通过（替补） 4：未通过 5：取消资格 6：已拒绝

export const APPOINTMENT_STATUS_ENUM = {
  PENDING: 0,
  UNDER_REVIEW: 1,
  PASS: 2,
  PASS_BACKUP: 3,
  UNPASS: 4,
  DISQUALIFY: 5,
  REJECT: 6
};
